import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Visitor Vehicle',
  path: '/homenet/visitorvehicle',
  redirect: '/homenet/visitorvehicle/list',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'List',
      'path': 'list',
      'meta': {
        'label': 'List'
      },
      'component': lazyLoading('homenet/VisitorVehicle')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/visitorVehicle.js